import { Component, OnInit, ViewChild } from '@angular/core';
import { AppState } from '../../../models/appState';
import { LogicService } from '../../../services/logic.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatTabChangeEvent, MatDialog, MatSelectChange } from '@angular/material';
import { SavingParameters, ScheduleDate } from '@akiba/models_bimbo';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { UiService } from '../../../services/ui.service';
import { UploadService } from '../../../services/upload.service';
import { Subscription } from 'rxjs';
import { DataSourceService } from '../../../services/data-source.service';
import * as moment from 'moment';
import { ShareSaving } from '../../../models/shareSaving';


@Component({
  selector: 'app-share-saving-parameters',
  templateUrl: './share-saving-parameters.component.html',
  styleUrls: ['./share-saving-parameters.component.scss']
})
export class ShareSavingParametersComponent implements OnInit {

  modParameter: ShareSaving | null = null;
  savingParameters: Array<ShareSaving> = new Array<ShareSaving>();
  ////////////////////////////////////////////////////////////////////
  dt = moment();
  minuteReset = this.dt.parseZone().utcOffset();
  isEdit = false;
  isNew = false;
  selectedIndex = 0;
  contentLocation: AppState = new AppState();

  //////////////////////////////////
  //////////////////////////////////
  shareSavingSubscription: Subscription = null;
  uploadSubscription: Subscription = null;

  //////////////////////////////////
  //////////////////////////////////

  tempPeriod: SavingParameters | null = null;

  //////////////////////////////////

  @ViewChild('name', { static: false }) name: any;
  constructor(public logicService: LogicService, public dialog: MatDialog, public ui: UiService, private uploadService: UploadService, private dataService: DataSourceService, public authService: AuthenticationService) {

    this.dataService.loadShareSavingsParameter().then(p => {
      if (p) {

        this.savingParameters = p.docs.map(x => {
          return new ShareSaving(x.data());
        });

      }


    });

  }

  async ngOnInit() {
    this.modParameter = new ShareSaving();
    this.contentLocation.savingParametersIndex = 0;

  }

  keyUpMethod(event: string) {
    if (event) {
      this.isNew = true;
    } else {
      this.isNew = false;
      this.contentLocation.savingParametersIndex = 0;
    }
  }

  tabChanged(event: MatTabChangeEvent): void {
    this.selectedIndex = event.index;
  }

  selectedPeriodChange(event: MatSelectChange) {

    if (!event.value) {
      this.isEdit = false;
      this.isNew = false;
      this.tempPeriod = null;
      this.modParameter = new ShareSaving();
    } else {
      this.isEdit = true;
      this.isNew = false;
      this.modParameter = event.value;
      this.tempPeriod = event.value;
    }

  }

  cancelPeriodChanges() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {
        this.reset();
      }
    });

  }

  savePeriod() {
    
    const authUser = this.logicService.dataManager.principalDataLoader.employee ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;
    this.modParameter.type = 7; //PeriodTypeEnum.permanentSaving add;
    this.modParameter.active = true;

    if (this.modParameter.savingParameter.minAmount < 1 || this.modParameter.savingParameter.minAmount > 1000000) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El monto mínimo de inscripción es requerida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.modParameter.savingParameter.maxDays < 1 || this.modParameter.savingParameter.maxDays > 100) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Los días para el cálculo del máximo son requeridos.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.modParameter.savingParameter.registrationDates || !this.modParameter.savingParameter.registrationDates.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de ingresar al menos un periodo de inscripción.',
          close: 'Aceptar'
        }
      });

      return;

    }


    if (!this.modParameter.savingParameter.includedCompanies || !this.modParameter.savingParameter.includedCompanies.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de incluir al menos una compañía.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.modParameter.savingParameter.contractTypes || !this.modParameter.savingParameter.contractTypes.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de incluir al menos un tipo de contrato.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.modParameter.title) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El nombre del ciclo es requerido.',
          close: 'Aceptar'
        }
      });

      return;

    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea guardar el ciclo con la información proporcionada?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    let subs = dialogConfirmation.afterClosed().subscribe(result => {

      this.modParameter.savingParameter.registrationDates = this.castRegistrationDateID (this.modParameter.savingParameter.registrationDates);

      if (result) {
        let createDate = new Date();
        let paramLogs = {
          changeID: '',
          collection: 'parameters',
          approvedUid: authUser.uid,
          approvedBy: {
            firstName: authUser.firstName,
            firstLastName: authUser.firstLastName,
            employeeNumber: authUser.workInformation.employeeNumber,
          },
          createDate: createDate,
          timeStamp: createDate.getTime()
        };

        if (this.modParameter.parametersID === '') {
          this.modParameter.parametersID = createDate.getTime().toString();
        }

        this.ui.showSpinner();


           if (this.modParameter.savingParameter.fileUploaded.file) {
   
             this.uploadService.pushUpload(this.modParameter.savingParameter.fileUploaded);
             this.uploadSubscription = this.uploadService.downloadURLSubject.subscribe(downloadURL => {
   
               const p = this.modParameter;
               p.savingParameter.fileUploaded.file = null;
               p.savingParameter.fileUploaded.downloadURL = downloadURL;
   
            
   
               if (this.uploadSubscription && !this.uploadSubscription.closed) {
                 this.uploadSubscription.unsubscribe();
                 this.uploadSubscription = null;
               }
   
               this.resetDates(p.savingParameter.registrationDates);
               p.savingParameter.fileUploaded = p.savingParameter.fileUploaded.toAny();
   
               const aPeriodObj : any = p.toAny();
               aPeriodObj.savingParameter.includedCompanies = aPeriodObj.savingParameter.includedCompanies.map(
                 company => Object.assign({}, company)
               );
   
               paramLogs.changeID = aPeriodObj.parametersID;
   
   
               this.dataService.saveLogAdministratorActions(paramLogs, 'shareSavingsParametersFileUploaded');
   
               this.dataService.saveShareSavingsParameter(aPeriodObj).then(() => {
   
                 this.reset();
                 this.ui.stopSpinner();
                 this.dialog.open(InfoDialogComponent, {
                   data: {
                     message: 'La información ha sido actualizada',
                     close: 'Aceptar'
                   }
                 });
   
               }).catch(error => {
                 this.ui.stopSpinner();
               });
   
             });
   
           } else {
   
             this.resetDates(this.modParameter.savingParameter.registrationDates);
             
             const aPeriodObj = this.modParameter.toAny();
   
             aPeriodObj.savingParameter.includedCompanies = aPeriodObj.savingParameter.includedCompanies.map(
               company => Object.assign({}, company)
             );
   
   
             paramLogs.changeID = aPeriodObj.parametersID;
   
             this.dataService.saveLogAdministratorActions(paramLogs, 'shareSavingsParameters');
             this.dataService.saveShareSavingsParameter(aPeriodObj).then(() => {
   
               this.reset();
               this.ui.stopSpinner();
               this.dialog.open(InfoDialogComponent, {
                 data: {
                   message: 'La información ha sido actualizada',
                   close: 'Aceptar'
                 }
               });
   
             }).catch(error => {
               this.ui.stopSpinner();
             });
   
           }

      }

      if (subs && !subs.closed) {
        subs.unsubscribe();
        subs = null;
      }

    });

  }

  castRegistrationDateID(registrationDates: Array<ScheduleDate>): any {
    let dataDates = new Array<any>();
    registrationDates.map(e => {
      const regDate = e.toAny();

      if(regDate.scheduleDateID == ''){
        regDate.scheduleDateID = regDate.startDate.getTime().toString();
      }

      dataDates.push(regDate);
    });

    return dataDates;

  }

  resetDates(dates: ScheduleDate[] | any) {
    if (dates.length > 0) {

      for (const iterator of dates) {
        let startMoment = moment(iterator.startDate).startOf('day');
        let endMoment = moment(iterator.endDate).startOf('day');
        iterator.startDate = startMoment.add(this.minuteReset, 'minutes').toDate();
        iterator.endDate = endMoment.add(this.minuteReset, 'minutes').toDate();
      }
    }
  }

  reset() {

    this.modParameter = new ShareSaving();
    this.tempPeriod = null;
    this.contentLocation.savingParametersIndex = 0;
    this.isNew = false;
    this.isEdit = false;
    this.name.reset();
    this.selectedIndex = 0;
  }

  ngOnDestroy(): void {

    if (this.uploadSubscription && !this.uploadSubscription.closed) {
      this.uploadSubscription.unsubscribe();
      this.uploadSubscription = null;
    }

  }

}
